<template>
  <div>
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-row>
        <!-- Form Section -->
        <v-col md="6" cols="12" v-if="form">
          <v-card class="neu-glow">
            <v-snackbar v-model="snackbar" absolute top right color="success">
              <span>Registration successful!</span>
              <v-icon dark>check_circle</v-icon>
            </v-snackbar>
            <v-card-title primary-title>
              <div class="text-h5">User Settings</div>
            </v-card-title>       
            <v-container grid-list-xl fluid>
              <v-row>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="First name"
                    outlined
                    dense
                    v-model="form.first"
                    :error-messages="fieldErrors('form.first')"
                    @blur="$v.form.first.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Last name"
                    outlined
                    dense
                    v-model="form.last"
                    :error-messages="fieldErrors('form.last')"
                    @blur="$v.form.last.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Email"
                    outlined
                    dense
                    v-model="form.email"
                    :error-messages="fieldErrors('form.email')"
                    @blur="$v.form.email.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Mobile"
                    outlined
                    dense
                    v-model="form.mobile"
                    :error-messages="fieldErrors('form.mobile')"
                    @blur="$v.form.mobile.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    color="primary"
                    label="Job"
                    outlined
                    dense
                    v-model="form.job"
                    :error-messages="fieldErrors('form.job')"
                    @blur="$v.form.job.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col md="6">
                  <v-select
                    color="pink"
                    label="Favorite Language"
                    v-model="form.locale"
                    required
                    outlined
                    dense
                    :items="locales"
                    :error-messages="fieldErrors('form.locale')"
                    @blur="$v.form.locale.$touch()"
                  ></v-select>
                </v-col>
                <v-col md="6">
                  <v-select
                    color="primary"
                    label="Favorite Currency"
                    v-model="form.currency"
                    required
                    outlined
                    dense
                    :items="currencies"
                    :error-messages="fieldErrors('form.currency')"
                    @blur="$v.form.currency.$touch()"
                  ></v-select>
                </v-col>
                <v-col md="6">
                  <v-select
                    color="primary"
                    label="Favorite Timezone"
                    v-model="form.timezone"
                    required
                    outlined
                    dense
                    :items="timezones"
                    :error-messages="fieldErrors('form.timezone')"
                    @blur="$v.form.timezone.$touch()"
                  ></v-select>
                </v-col>
                <v-col md="6">
                  <avatar />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <!-- Code Review -->
        <v-col md="6" cols="12">
          <v-card class="neu-glow">
            <v-card-title primary-title>
              <div class="text-h5">Company Settings</div>
            </v-card-title>
            <v-container grid-list-xl fluid>
              <v-row>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Company"
                    outlined
                    dense
                    v-model="form.company"
                    :error-messages="fieldErrors('form.company')"
                    @blur="$v.form.company.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Address"
                    outlined
                    dense
                    v-model="form.address"
                    :error-messages="fieldErrors('form.address')"
                    @blur="$v.form.address.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Postal Code"
                    outlined
                    dense
                    v-model="form.postalcode"
                    :error-messages="fieldErrors('form.postalcode')"
                    @blur="$v.form.postalcode.$touch()"
                    @input="$v.form.postalcode.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="City"
                    outlined
                    dense
                    v-model="form.city"
                    :error-messages="fieldErrors('form.city')"
                    @blur="$v.form.city.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="State"
                    outlined
                    dense
                    v-model="form.state"
                    :error-messages="fieldErrors('form.state')"
                    @blur="$v.form.state.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-select
                    color="primary"
                    label="Country"
                    v-model="form.country"
                    required
                    outlined
                    dense
                    :items="countries"
                    :error-messages="fieldErrors('form.country')"
                    @blur="$v.form.country.$touch()"
                  ></v-select>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Company ID"
                    outlined
                    dense
                    v-model="form.companyid"
                    :error-messages="fieldErrors('form.companyid')"
                    @blur="$v.form.companyid.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-text-field
                    color="primary"
                    label="Tax ID"
                    outlined
                    dense
                    v-model="form.vatnumber"
                    :error-messages="fieldErrors('form.vatnumber')"
                    @blur="$v.form.vatnumber.$touch()"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="6" cols="12">
                  <v-combobox
                    color="primary"
                    label="CPA"
                    v-model="form.cpa"
                    required
                    outlined
                    dense
                    :items="cpas"
                    :error-messages="fieldErrors('form.cpa')"
                    @blur="$v.form.cpa.$touch()"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <!--
        <v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="$v.$invalid"
              >Save</v-btn
            >
          </v-card-actions>
        </v-col>
        -->
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { required, email, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableLocale } from "@/config/locale";
import { availableCurrency } from "@/config/locale";
import { availableCountries  } from "@/config/countries";
import { availableTimeZones  } from "@/config/timezones";
import avatar from "./AvatarMain";
const defaultForm = {
  first: "",
  last: "",
  email: "",
  mobile: "",
  job: "",
  locale: "en",
  currency: "eur",
  timezone: "Israel Standard Time",
  company: "",
  address: "",
  postalcode: "",
  city: "",
  state: "",
  country: "",
  companyid: "",
  vatnumber: "",
  cpa: "",
  age: null,
  terms: false,
};

export default {
  components:{
    avatar
  },
  mixins: [validationMixin],
  validations: {
    form: {
      first: { required },
      last: { required },
      email: { required, email },
      mobile: { required },
      job: { required },
      locale: { required },
      currency: { required },
      timezone: { required },
      company: { required },
      address: { required },
      city: { required },
      state: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      cpa: { required },
      postalcode: { required, maxLength: maxLength(8) },
    },
  },
  validationMessages: {
    form: {
      first: { required: "First name is required" },
      last: { required: "Last name is required" },
      mobile: { required: "Mobile is required" },
      job: { required: "Job is required" },
      locale: { required: "Choose your favorite language" },
      currency: { required: "Choose your favorite currency" },
      timezone: { required: "Choose your favorite currency" },
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      city: { required: "City is required" },
      state: { required: "State is required" },
      country: { required: "State is required" },
      companyid: { required: "State is required" },
      vatnumber: { required: "State is required" },
      cpa: { required: "State is required" },
      email: {
        required: "Email is required",
        email: "Email must be valid",
      },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      form: Object.assign({}, defaultForm),
      locales: availableLocale,
      currencies: availableCurrency,
      countries: availableCountries,
      timezones:availableTimeZones,
      snackbar: false,
      
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.snackbar = true;
      this.resetForm();
      this.$v.$reset();
    },
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>
<style scoped>
.json-pre {
  min-height: 748px;
  max-height: 748px;
  height: 748px;
  overflow-y: auto;
}
</style>
